import { topicsData } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            话题广场
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            热门话题标签聚合，快速找到你感兴趣的吃瓜方向
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicsData.map((topic) => (
            <a
              key={topic.id}
              href="#cards"
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                topic.hot
                  ? 'bg-accent-500 text-background-50 dark:text-foreground-950 hover:bg-accent-600'
                  : 'bg-background-50 border border-background-200/70 text-foreground-700 hover:border-primary-200/60 hover:text-primary-600'
              }`}
            >
              {topic.hot && (
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-fire-line text-xs"></i>
                </span>
              )}
              <span>{topic.name}</span>
              <span className={`text-xs ${topic.hot ? 'text-background-50/70 dark:text-foreground-950/70' : 'text-foreground-400'}`}>
                {topic.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}